import moment from 'moment-timezone'

export function dateTimeToDisplay (date: number | string) {
  if (!moment(date).isValid()) {
    return ''
  }
  if (typeof date === 'number') {
    return moment.unix(date).tz('America/New_York').format('MM/DD/YYYY h:mm:ss A')
  } else {
    return moment.utc(date).tz('America/New_York').format('MM/DD/YYYY h:mm:ss A')
  }
}

export function dateToDisplay (date: number | string) {
  if (!moment(date).isValid()) {
    return ''
  }
  if (typeof date === 'number') {
    return moment.unix(date).tz('America/New_York').format('MM/DD/YYYY')
  } else {
    return moment.utc(date).tz('America/New_York').format('MM/DD/YYYY')
  }
}

export function dateTimeToParse (date: string | number) {
  if (!moment(date).isValid()) {
    return ''
  }
  if (typeof date === 'number') {
    return moment.unix(date).tz('America/New_York').format('YYYY-MM-DD')
  } else {
    return moment.utc(date).tz('America/New_York').format('YYYY-MM-DD')
  }
}

export function monthToParse (date: string | number) {
  if (!moment(date).isValid()) {
    return ''
  }
  if (typeof date === 'number') {
    return moment.unix(date).tz('America/New_York').format('YYYY-MM')
  } else {
    return moment.utc(date).tz('America/New_York').format('YYYY-MM')
  }
}

export function monthToDisplay (date: string | number) {
  if (!moment(date).isValid()) {
    return ''
  }
  if (typeof date === 'number') {
    return moment.unix(date).tz('America/New_York').format('MMM YYYY')
  } else {
    return moment.utc(date).format('MMM YYYY')
  }
}

export function dateTimeToUnix (date: string) {
  if (!moment(date).isValid()) {
    return ''
  }
  return moment.tz(date, 'America/New_York').unix()
}

export function todayToParse () {
  return moment.tz('America/New_York').format('YYYY-MM-DD')
}

export function monthNames (month: string): string {
  const _month = month.length > 1
    ? month
    : '0' + month

  const names: {
    [key: string]: string;
  } = {
    '01': 'Jan.',
    '02': 'Feb.',
    '03': 'Mar.',
    '04': 'Apr.',
    '05': 'May',
    '06': 'June',
    '07': 'July',
    '08': 'Aug.',
    '09': 'Sept.',
    '10': 'Oct.',
    '11': 'Nov.',
    '12': 'Dec.'
  }
  return names[_month]
}

export function monthNumber (monthName: string): string {
  const names: {
    [key: string]: string;
  } = {
    'Jan.': '01',
    'Feb.': '02',
    'Mar.': '03',
    'Apr.': '04',
    'May': '05',
    'June': '06',
    'July': '07',
    'Aug.': '08',
    'Sept.': '09',
    'Oct.': '10',
    'Nov.': '11',
    'Dec.': '12'
  }
  return names[monthName]
}

export function dateToNow (date: string | number): string {
  const dateNum = Number(date)
  const now = moment.tz('America/New_York').unix()
  if (!date) {
    return '-'
  }
  if (isNaN(dateNum)) {
    return moment(date).isBefore(moment())
      ? moment(date).toNow()
      : moment(date).fromNow()
  }
  return dateNum < 946656000
    ? dateNum > now ? moment(dateNum).fromNow() : moment(dateNum).toNow()
    : dateNum > now ? moment.unix(dateNum).fromNow() : moment.unix(dateNum).toNow()
}

export function monthStartToUnix (date: number) {
  if (!moment(date).isValid()) {
    return ''
  }
  return moment.unix(date).tz('America/New_York').startOf('month').unix()
}

export function monthEndToUnix (date: number) {
  if (!moment(date).isValid()) {
    return ''
  }
  return moment.unix(date).tz('America/New_York').endOf('month').unix()
}
